import { useNavigate } from 'react-router-dom';
import { useWizardStore } from '../store/wizardStore';

export function LandingPage() {
  const navigate = useNavigate();
  const reset = useWizardStore((s) => s.reset);

  function handleStart() {
    reset();
    navigate('/wizard');
  }

  return (
    <div className="syhouse-min-screen flex min-h-screen flex-col items-center justify-center bg-smartify-paper px-4 py-10">
      <div className="syhouse-standalone-only mb-8 flex items-center gap-3">
        <div className="h-12 w-12 rounded-smartify bg-smartify-brand" />
        <div>
          <h1 className="text-2xl font-bold text-smartify-ink">SYHouse</h1>
          <p className="text-sm text-smartify-muted">Configurador Smartify</p>
        </div>
      </div>

      <div className="w-full max-w-md rounded-smartify bg-white p-8 shadow-sm">
        <h2 className="mb-2 text-xl font-semibold text-smartify-ink">
          Projeta a tua casa inteligente
        </h2>
        <p className="mb-6 text-sm leading-relaxed text-smartify-muted">
          Escolhe a tipologia, configura cada divisão e descobre os produtos Smartify
          ideais para ti — sem compromissos.
        </p>

        <ul className="mb-6 space-y-2 text-sm text-smartify-muted">
          <li className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-smartify-brand text-xs text-white">1</span>
            Escolhe a tipologia (T0 a Moradia)
          </li>
          <li className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-smartify-brand text-xs text-white">2</span>
            Activa as divisões que queres configurar
          </li>
          <li className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-smartify-brand text-xs text-white">3</span>
            Adiciona componentes divisão a divisão
          </li>
          <li className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-smartify-brand text-xs text-white">4</span>
            Vê o orçamento estimado e pede proposta
          </li>
        </ul>

        <button
          type="button"
          onClick={handleStart}
          className="w-full rounded-smartify bg-smartify-brand px-6 py-3 font-semibold text-white transition-opacity hover:opacity-90"
        >
          Começar configuração →
        </button>
      </div>

      <p className="syhouse-standalone-only mt-6 text-xs text-smartify-muted">
        As tuas escolhas ficam guardadas neste browser. Sem necessidade de conta.
      </p>
    </div>
  );
}
